import { NgModule } from "@angular/core";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { UIStateDirective, UIStateErrorComponent, UIStateSpinnerComponent } from "./ui-state.directive";
export { UIState, UIStateSpinnerSize } from "./ui-state.directive";

@NgModule({
  declarations: [
    UIStateDirective,
    UIStateSpinnerComponent,
    UIStateErrorComponent
  ],
  imports: [
    MatProgressSpinnerModule
  ],
  exports: [
    UIStateDirective,
  ]
})
export class UIStateModule {}
